import { observable } from 'mobx';

export type ForeignRegionResponseArgs = {
  id: number;
  name: string;
  ministry_of_foreign_affairs_id: string | null;
  created_at: string;
  updated_at: string;
};

export type ForeignRegionArgs = {
  id: number;
  name: string;
  ministryOfForeignAffairsId: string | null;
  createdAt: string;
  updatedAt: string;
};

export const convertForeignRegionResponseToArgs = (response: ForeignRegionResponseArgs): ForeignRegionArgs => {
  return {
    id: response.id,
    name: response.name,
    ministryOfForeignAffairsId: response.ministry_of_foreign_affairs_id,
    createdAt: response.created_at,
    updatedAt: response.updated_at
  };
};

export default class ForeignRegion {
  @observable id: number;
  @observable name: string;
  @observable ministryOfForeignAffairsId: string | null;
  @observable createdAt: string;
  @observable updatedAt: string;

  constructor(args: ForeignRegionArgs) {
    this.id = args.id;
    this.name = args.name;
    this.ministryOfForeignAffairsId = args.ministryOfForeignAffairsId;
    this.createdAt = args.createdAt;
    this.updatedAt = args.updatedAt;
  }

  get submitParams() {
    return {
      name: this.name,
      ministry_of_foreign_affairs_id: this.ministryOfForeignAffairsId
    };
  }

  static createEmpty(): ForeignRegion {
    return new ForeignRegion({
      id: 0,
      name: '',
      ministryOfForeignAffairsId: null,
      createdAt: '',
      updatedAt: ''
    });
  }
}
